import React from 'react';

export function OffRampStepFrame({
    stepNumber,
    title,
    hint,
    engTag,
    optional,
    children,
}: {
    stepNumber: number;
    title: string;
    hint?: string;
    engTag?: string;
    optional?: boolean;
    children: React.ReactNode;
}) {
    return (
        <section className="space-y-3">
            <div className="flex items-start gap-3">
                <span
                    className="shrink-0 w-7 h-7 rounded-full bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center"
                    aria-hidden
                >
                    {stepNumber}
                </span>
                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
                        {optional && (
                            <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
                                Optional
                            </span>
                        )}
                        {engTag && (
                            <span className="text-[10px] font-mono text-muted-foreground/70">{engTag}</span>
                        )}
                    </div>
                    {hint && <p className="text-xs text-muted-foreground mt-0.5">{hint}</p>}
                </div>
            </div>
            {children}
        </section>
    );
}
